const SHOW_AFTER_SCROLL_PX = 320;
function setVisible(button, visible) {
    button.classList.toggle("opacity-100", visible);
    button.classList.toggle("translate-y-0", visible);
    button.classList.toggle("opacity-0", !visible);
    button.classList.toggle("pointer-events-none", !visible);
    button.classList.toggle("translate-y-4", !visible);
    button.tabIndex = visible ? 0 : -1;
}
export const ScrollToTop = (element) => {
    const button = element instanceof HTMLButtonElement ? element : element.querySelector("button");
    if (!(button instanceof HTMLButtonElement)) {
        return;
    }
    const onScroll = () => {
        setVisible(button, window.scrollY > SHOW_AFTER_SCROLL_PX);
    };
    const onClick = () => {
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
    };
    button.addEventListener("click", onClick);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
        button.removeEventListener("click", onClick);
        window.removeEventListener("scroll", onScroll);
    };
};
